import React, { useEffect, useState } from "react";
import axios from "axios";
import "./DepartmentTable.css";
import { useParams } from "react-router-dom";
import { API_URL, ENDPOINTS } from "../../constants/api";

const DepartmentTable = () => {
  const apiKey =
    "3f72ef31838a6cf7e082718614350592a56d06a57ba48e1206addf949b1734bd662265d87239cbd582ae3be050606943";

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { departmentId } = useParams();
  console.log('departmentid=',departmentId)

  useEffect(() => {
    if (!departmentId) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/Course-Detail`,
          {
            headers: { "x-api-key": apiKey },
          }
        );
        console.log('course department:',res.data.report)

        // filter rows by departmentId
        const filtered = res.data.report.filter(
          (item) => String(item.id) === String(departmentId)
        );
        setData(filtered);
      } catch (err) {
        console.error("Error fetching department data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [departmentId]);

  return (
    <div className="dept-table-container">
      {loading ? (
        <p className="loading-text">Loading data...</p>
      ) : data.length > 0 ? (
        <table className="dept-table">
          <thead>
            <tr>
              <th>No</th>
              <th>Year</th>
              <th>Semester</th>
              <th>Course</th>
              <th>Credit Hours</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={row.id}>
                <td>{index + 1}</td>
                <td>{row.Year}</td> {/* Make sure API has "year" field */}
                <td>{row.Semester}</td>
                <td>{row.Course}</td>
                <td>{row.Credit_Hours} Hour</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="no-data">No data found for this department.</p>
      )}
    </div>
  );
};

export default DepartmentTable;
